module.exports = __webpack_public_path__ + "static/media/jonathan_fan.a3f9f263.png";